import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../features/tasks/tasksApi";
import AddNewBtn from "./AddNewBtn";
import Main from "./Main";
import Task from "./Task";
import Error from "./ui/Error";
import Loading from "./ui/Loading";

export default function TasksList() {
  const { data: tasks, isLoading, isError, error } = useGetTasksQuery();

  const { unCheckedProjects, search } = useSelector((state) => state.filters);

  // const checkedProjects = projects?.filter((project) => project.projectName);

  const searchedTask = tasks?.filter((task) =>
    task.taskName.toLowerCase().includes(search.toLowerCase())
  );
  const filteredTask = searchedTask?.filter((task) => {
    return !unCheckedProjects?.some(
      (t) => t.projectName === task.project.projectName
    );
  });

  useEffect(() => {}, [unCheckedProjects, search]);

  // deciding what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && filteredTask?.length === 0) {
    content = <div>No tasks found!</div>;
  } else if (!isLoading && !isError && filteredTask?.length > 0) {
    content = filteredTask.map((task) => {
      return <Task key={task.id} task={task} />;
    });
  }
  return (
    <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
      <Main>
        <AddNewBtn />
        <div className="lws-task-list">{content}</div>
      </Main>
    </div>
  );
}
